<template>
  <ege-page />
</template>

<script>
import EgePage from '~/components/v2/ege/EgeOldPage.vue';

export default {
  name: 'EgeCityPage',
  components: { EgePage },
  layout: 'DefaultLayoutV2',
  scrollToTop: true,
};
</script>
